export default "__VITE_ASSET__1c9644c6__"